export default __webpack_public_path__ + "static/europe-no-uk-9aaebdc10d867f0d6251241fde7e5bb5.svg";